module.exports = __webpack_public_path__ + "static/media/sawi.074aaee8.jpeg";